module.exports = __webpack_public_path__ + "img/ic-ba-acc.ded83a64.svg";